import BackgroundSection from "components/backgrounds/BackgroundSection";
import FormFieldSelect from "components/campos/select";
import Heading from "components/heading/Heading";
import Button from "componentsTemplate/Button/Button";
import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import Label from "componentsTemplate/Label/Label";
import Select from "componentsTemplate/Select/Select";
import { set } from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getGroupCities, getGroupCitiesFilteredUser, getGroupCitiesMissing, postGroupCitiesMissing } from "services/GroupCityService";
import { getInstitutional, InstitutionalResponse } from "services/PageService";
import { showToastError, showToastSuccess, showToastWarning } from "utils/toasts";
import image from "./security.svg";

const NotAuthorization: React.FC = () => {

  const navigate = useNavigate();
  const urlBase = process.env.REACT_APP_BACKEND_API_URL + '/storage/images/institutional/banners/';
  const [institutional, setInstitutional] = useState<InstitutionalResponse | null>(null);
  const [cities, setCities] = useState<any[]>([]);

  return (
    <div className={`nc-LayoutPage relative`}>
      <div className={`absolute h-full top-0 left-0 right-0 w-full bg-primary-100 bg-opacity-25`}/>
        <div className="container relative sm:py-10">
          <div className="p-1 mx-auto bg-white rounded-xl sm:rounded-3xl lg:rounded-[40px] shadow-lg sm:p-10 lg:p-16 ">

            <Heading isCenter desc="">
              Parece que você não tem acesso a esse conteúdo
            </Heading>

            <div className="flex justify-center my-5">
              <img
                src={image}
                alt="Ilustração de erro 403"
                className="w-60 h-60"
              />
            </div>

            <div className="flex justify-center text-lg text-primary-500">
              Para continuar veja os nossos planos, e escolha o que melhor se encaixa com você.
            </div>

            <div className="flex justify-center gap-3">
              <Button
                pattern="third"
                className="my-10 w-60"
                type="button"
                onClick={() => navigate('/')}
              >
                Voltar
              </Button>

              <ButtonPrimary
                className="my-10 w-60"
                type="button"
                onClick={() => navigate('/planos')}
              >
                Ver Planos
              </ButtonPrimary>
            </div>
          </div>
        </div>
      </div>
    );
};

export default NotAuthorization;
